(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["datalake_event_tracker"] = factory();
	else
		root["datalake_event_tracker"] = factory();
})(globalThis, () => {
return 